import ssoImg1 from "./../../../../assets/images/Survay-img.png"; // Adjust the path as necessary


function SmallVesselsSafetySurveysTab() {
  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        Small vessels safety{" "}
        <span className="text-orange-ef3e33 font-400"> SURVEYS </span>
      </div>

      <div className="row g-3 g-sm-4 g-md-4 g-lg-5">
        {/* <div className="col-lg-5">
          <img src={ssoImg1} className="img-fluid rounded-1" alt="" />
        </div> */}
        <div className="col-lg">
          <div className="">
            <p className="mb-4 font-18 font-900">
           ​​​Boating - Safety Surveys
          </p>

          <p className="mb-4">
            In order to better comply with our mandate SAMSA has appointed  safety officers from authorised agencies (organised  sporting bodies) to ensure the safety, marking and certification of  pleasure vessels under 9 metres in length. 
SAMSA has also appointed  SAMSA appointed external surveyors, to ensure the safety, marking and certification of pleasure vessels.


          </p>

          <p className="mb-4">
            Please note that SAMSA has the following survey framework:-
          </p>
          </div>
          <div className="accordion blackTab" id="blackTab">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabOne"
                  aria-expanded="false"
                  aria-controls="blackTabOne"
                >
                  SAMSA Employed Internal Surveyors
                </button>
              </h2>
              <div
                id="blackTabOne"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <p className="mb-3">These surveyors are affiliated with a SAMSA Port Office (Including Pretoria Head office) under the control of the Principal Officer in charge of that office. </p>

                  <p >These surveyors are employed permanently and remunerated by SAMSA.</p>
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button "
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabTwo"
                  aria-expanded="true"
                  aria-controls="blackTabTwo"
                >
                  SAMSA External Appointed Surveyors
                </button>
              </h2>
              <div
                id="blackTabTwo"
                className="accordion-collapse collapse show"
                
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <p className="mb-3">The external appointed SAMSA surveyor is not employed by SAMSA, but are entrusted with the implementation of SAMSA policy regarding the survey of small vessels.</p>

                  <p >SAMSA external surveyors report directly to the local Principal Officer in their area of appointment. There is no remuneration paid by SAMSA for the services rendered by an external surveyor.</p>
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabThree"
                  aria-expanded="false"
                  aria-controls="blackTabThree"
                >
                  Authorised Agency Appointed Safety Officers
                </button>
              </h2>
              <div
                id="blackTabThree"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <p className="mb-3">These are officers appointed by Authorised Agencies. The Safety Officer will report directly to the agency. There is no remuneration paid by SAMSA for the services rendered by a safety officer. </p>

                  <p ><b>The Safety officer is not a “SAMSA Surveyor”</b> but affiliated to an organised sporting body.</p>
                </div>
              </div>
            </div>
            
          </div>
        </div>
        
        
      </div>
    </>
  );
}

export default SmallVesselsSafetySurveysTab;
